module.exports = __webpack_public_path__ + "static/img/kdic-competition.54402b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kdic-competition.jpg
// module id = GR9f
// module chunks = 0